<template>
    <validator name="validator">
        <form novalidate>
            <div class="card card-content">
                <div class="card-header">
                    <div class="header">
                      <div class="breadcrumb">
                        <a class="breadcrumb-item" v-link="{path: '/'}">Accueil</a>
                        <a class="breadcrumb-item" v-link="{ path: '/project/list'}">Gestion des parcours</a>
                        <a class="breadcrumb-item" v-link="{ path: '/project/add'}">Ajouter</a>
                      </div>
                        <h1>Ajouter un parcours</h1>
                    </div>
                    <div class="actions">
                        <a class="btn btn-link" v-link="{ path: '/project/list' }">Voir tous les parcours</a>
                        <button class="btn btn-link" v-on:click.prevent="saveProject" :class="{ disabled: !$validator.valid }">Sauvegarder le parcours</button>
                    </div>
                </div>
                <div class="card-block">
                    <fieldset>
                        <legend>Informations générales</legend>
                        <div class="form-group">
                            <label for="info_project">Parcours *</label>
                            <select
                            id      = "info_project"
                            name    = "info_project"
                            v-model = "info_project"
                            class   = "form-control"
                            v-validate:project_type_id = "validationRules.project_type_id"
                            @change = "showForm()"
                            >
                            <option value=""></option>
                            <option v-for="projectType in projectTypes" v-bind:value="{ id: projectType.id, name: projectType.name}">{{ projectType.name }}</option>
                            </select>
                            <small class="form-text text-danger" v-if="$validator.project_type_id.required">Vous devez choisir un parcours</small>
                            <input type="hidden" id="project.project_type_id" name="name" v-model="info_project.id" value="" />
                            <input type="hidden" id="project.name" name="name" v-model="info_project.name" value="" />
                        </div>
                        <div class="form-group">
                            <label for="name">Statut *</label>
                            <select
                              id      = "project_status_id"
                              name    = "project_status_id"
                              v-model = "project.project_status_id"
                              class   = "form-control"
                              v-validate:status = "validationRules.status"
                            >
                                <option value=""></option>
                                <option value="1">Ouvert</option>
                                <option value="2">Fermé</option>
                                <option value="3">En attente</option>
                                <option v-for="intituleStatut in projectStatus" :value="intituleStatut.value">{{ intituleStatut.label }}</option>
                            </select>
                          <!--<small class="form-text text-danger" v-if="$validator.status.required">Vous devez choisir un statut</small>-->
                      </div>
          <legend>Contact</legend>
          <!-- Contact -->
		        <div class="form-group">
                            <label for="contact">Participant</label>
                            <select
                            id      = "contact"
                            class   = "form-control"
                            v-model = "project.contact_id"
                            v-validate:participant = "validationRules.participant"
                            >
                            <option value=""></option>
                            <option v-for="contact of contacts" :value="contact.id" :class="[contact.id == currentContact.id ? 'me' : '']" :selected="contact.id == currentContact.id" >
                                {{ contact.leader_lastname }} {{ contact.leader_firstname }}
                            </option>
                            </select>
                        <small class="form-text text-danger" v-if="$validator.participant.required">Vous devez choisir un participant</small>
		        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Date contact -->
                                <div class="form-group">
                                    <label for="contact_date_fl">Date prise de contact / réception FL</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.contact_date_fl"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "contact_date_fl"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.contact_date_fl"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.contact_date_fl.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date entree -->
                                <div class="form-group">
                                    <label for="first_meeting_date">Date entrée / 1er rendez-vous effectif</label>
                                    <!--
                                    <date-picker
                                            :time.sync = "project.first_meeting_date"
                                            :option    = "datepickerOptions"
                                            :inputClass = "form-control"
                                    ></date-picker>
       	       	       	       	    -->
                                    <input
                                      id               = "first_meeting_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.first_meeting_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.first_meeting_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date reunion info -->
                                <div class="form-group">
                                    <label for="meeting_date_incubator_info">Date réunion info</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.meeting_date_incubator_info"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
       	       	       	       	    -->
                                    <input
                                      id               = "meeting_date_incubator_info"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.meeting_date_incubator_info"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.meeting_date_incubator_info.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date dossier -->
                                <div class="form-group">
                                    <label for="incubator_application_deposit_date">Date dépôt dossier</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.incubator_application_deposit_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "incubator_application_deposit_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.incubator_application_deposit_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.incubator_application_deposit_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Referent -->
                                <div class="form-group">
                                    <label for="name">Conseiller référent</label>
                                  <select id="referentadviser_id" name="referentadviser_id" v-model="project.referentadviser_id" class="form-control">
                                    <option value=""></option>
                                    <option v-for="referentAdviser in firstintervenants" :value="referentAdviser.id">{{ referentAdviser.firstname }} {{ referentAdviser.lastname }}</option>
                                  </select>
                                    <!--<small class="form-text text-danger" v-if="$validator.referent_adviser.required">Vous devez indiquer un référent</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Lieu de suivi -->
                                <div class="form-group">
                                    <label for="name">Lieu de suivi</label>
		                    <select id="tracking_place" name="tracking_place" v-model="project.tracking_place" class="form-control">
		                        <option value=""></option>
		                        <option v-for="trackingPlace in trackingPlaces" :value="trackingPlace.id">{{ trackingPlace.name }}</option>
		                    </select>
                                    <!--<small class="form-text text-danger" v-if="$validator.tracking_place.required">Vous devez indiquer un lieu de suivi</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Numéro adhésion -->
                                <div class="form-group">
                                <label for="">N° adhésion</label>
                                <input
                                    id               = "adhesion_num"
                                    class            = "form-control"
                                    type             = "text"
                                    v-model          = "project.adhesion_num"
                                >
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date sortie -->
                                <div class="form-group">
                                    <label for="exit_date">Date de sortie</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "project.exit_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
       	       	       	       	    -->
                                    <input
                                      id               = "exit_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "project.exit_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.last_meeting_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <br>
                    <fieldset>
                        <legend>Observations</legend>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <textarea rows="10" id="fs_observations" v-model="project.fs_observations" placeholder="" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="card-footer">
                    <div class="actions">
                        <a class="btn btn-link" v-link="{ path: '/project/list'}">Voir tous les parcours</a>
                        <button class="btn btn-link" v-on:click.prevent="saveProject" v-if="$validator.valid">Sauvegarder le parcours</button>
                    </div>
                </div>
            </div>
        </form>
    </validator>
</template>


<script>
// Npm packages
import toastr from 'toastr'
import DatePicker from 'vue-datepicker/vue-datepicker-1.vue'
import { Switch } from 'mint-ui'
import Breadcrumb from '../nav/Breadcrumb.vue'

// Vuex specifics
import { addProject } from 'src/vuex/actions/projectActions'
import { getProjectTypes } from 'src/vuex/actions/projectTypesActions'
import { getProjectStatus } from 'src/vuex/actions/projectStatusActions'
import { getContacts, getContact } from 'src/vuex/actions/contactActions'
import { getUsers } from 'src/vuex/actions/userActions'
// import { getReferentAdvisers } from 'src/vuex/actions/referentAdvisersActions'
import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
import { getTrackingPlaces } from 'src/vuex/actions/trackingPlacesActions'

import moment from 'moment'

import {
  /*
  familySituations,
  partnerSituations,
  */
  contact as currentContact,
  contacts,
  users,
  projectTypes,
  // referentAdvisers,
  firstintervenants,
  trackingPlaces,
  projectStatus
} from 'src/vuex/getters'
// import { getIssues } from 'src/vuex/actions/familySituationsActions'

// Validations
import { add as validationRules } from 'src/validations/project.js'

// Options
import { datepickerOptions } from 'src/options/date'

export default{
  vuex: {
    getters: {
      /*
      familySituations,
      partnerSituations,
      */
      currentContact,
      contacts,
      users,
      projectTypes,
      // referentAdvisers,
      firstintervenants,
      trackingPlaces,
      projectStatus,
      projectCreated: ({ projects }) => projects.projectCreated
    },
    actions: {
      addProject,
      getContact,
      getContacts,
      getUsers,
      getProjectTypes,
      // getReferentAdvisers,
      getFirstintervenants,
      getTrackingPlaces,
      getProjectStatus
      /*,
      getEducationLevels,
      getFamilySituations
      */
    }
  },
  validators: {
  },
  data () {
    return {
      datepickerOptions,
      project: {
        date: '2018-10-10',
        name: null
      },
      validationRules,
      showModal: false
    }
  },
  created () {},
  watch: {
    'projectCreated': function (value) {
      if (value !== false) {
        toastr.success('Nouveau parcours ajouté')
        // this.$router.go('/project/edit/' + projectCreated)
        // this.$router.go('/project/list/')
        // console.log('GO TO ' + this.project.contact_id)
        this.$router.go('/contact/parcours/' + this.project.contact_id)
      }
    }
  },
  methods: {
    saveProject () {
      this.project.project_type_id = this.info_project.id
      this.project.name = this.info_project.name
      console.log('dd '	+ this.project.project_type_id + ' ' + this.project.name + ' ' + this.project.contact_date_fl + ' VS ' + this.contact_date_fl)
      if (typeof (this.project.contact_date_fl) === 'undefined' || this.project.contact_date_fl === null || this.project.contact_date_fl === '' || this.project.contact_date_fl === 'undefined' || this.project.contact_date_fl === 'Invalid_date') {
        this.project.contact_date_fl = ''
      } else {
        this.project.contact_date_fl = moment(this.project.contact_date_fl, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.incubator_application_deposit_date) === 'undefined' || this.project.incubator_application_deposit_date === null || this.project.incubator_application_deposit_date === '' || this.project.incubator_application_deposit_date === 'undefined' || this.project.incubator_application_deposit_date === 'Invalid date') {
        this.project.incubator_application_deposit_date = ''
      } else {
        this.project.incubator_application_deposit_date = moment(this.project.incubator_application_deposit_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.meeting_date_incubator_info) === 'undefined' || this.project.meeting_date_incubator_info === null || this.project.meeting_date_incubator_info === '' || this.project.meeting_date_incubator_info === 'undefined' || this.project.meeting_date_incubator_info === 'Invalid date') {
        this.project.meeting_date_incubator_info = ''
      } else {
        this.project.meeting_date_incubator_info = moment(this.project.meeting_date_incubator_info, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.first_meeting_date) === 'undefined' || this.project.first_meeting_date === null || this.project.first_meeting_date === '' || this.project.first_meeting_date === 'undefined' || this.project.first_meeting_date === 'Invalid date') {
        this.project.first_meeting_date = ''
      } else {
        this.project.first_meeting_date = moment(this.project.first_meeting_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (typeof (this.project.exit_date) === 'undefined' || this.project.exit_date === null || this.project.exit_date === '' || this.project.exit_date === 'undefined' || this.project.exit_date === 'Invalid date') {
        this.project.exit_date = ''
      } else {
        this.project.exit_date = moment(this.project.exit_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      console.log('date ' + this.project.contact_date_fl + ' ' + this.project.incubator_application_deposit_date + ' ' + this.project.meeting_date_incubator_info + ' ' + this.project.first_meeting_date + ' ' + this.project.exit_date)
      /*
      let contactTmp
      contactTmp = this.contacts[this.project.contact_id]
      this.project.contact_gender = contactTmp.gender
      this.project.contact_firstname = contactTmp.leader_firstname
      this.project.contact_lastname = contactTmp.leader_lastname
      // console.log('contact ' + this.project.contact_id + ' VS ' + contactTmp.id + ' ' + contactTmp.leader_lastname + ' ' + contactTmp.leader_firstname)
      let contactTmps
      for (contactTmps in this.contacts) {
        if (contactTmps.id === this.project.contact_id) {
          contactTmp = contactTmps
        }
      }
      this.project.contact_gender = contactTmp.gender
      this.project.contact_firstname = contactTmp.leader_firstname
      this.project.contact_lastname = contactTmp.leader_lastname
      // console.log('contact ' + this.project.contact_id + ' VS ' + contactTmp.id + ' ' + contactTmp.leader_lastname + ' ' + contactTmp.leader_firstname)
      */
      this.getContact(this.project.contact_id)
        .then(() => {
          this.project.contact_gender = this.currentContact.gender
          this.project.contact_firstname = this.currentContact.leader_firstname
          this.project.contact_lastname = this.currentContact.leader_lastname
          console.log('contact ' + this.project.contact_date_fl + ' : ' + this.project.contact_id + ' VS ' + this.currentContact.id + ' ' + this.currentContact.leader_lastname + ' ' + this.currentContact.leader_firstname)
          this.addProject(this.project)
        })
    },
    showForm (e) {
      // console.log('trget ' + e.target.options.selectedIndex)
      // console.log('changeParcours' + JSON.stringify(project_type_id.name))
    }
  },
  components: { 'date-picker': DatePicker, Switch, Breadcrumb },
  ready () {
    this.$dispatch('preview-data', [])
    this.getProjectTypes()
    this.getProjectStatus()
    // this.getReferentAdvisers()
    this.getFirstintervenants()
    this.getTrackingPlaces()
    this.getContacts()
    this.getUsers()
    /*
this.getContact(this.$route.params.contactId)
    this.getFamilySituations()
    this.getPartnerSituations()
    */
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ProjectAdd.vue?d680cb58